import { SUBTYPE, TYPE } from '@kontentino/kontentino-constants/Posts';

const PostTypeUtils = {
  typeName: {
    [TYPE.COMMENT]: 'text',
    [TYPE.LINK]: 'link',
    [TYPE.PHOTO]: 'image',
    [TYPE.GALLERY]: 'gallery',
    [TYPE.VIDEO]: 'video',
    [TYPE.AD]: 'ad',
    [TYPE.DOCUMENT]: 'document',
  } as { [x: number]: string },
  subtypeName: {
    [SUBTYPE.REEL]: 'reel',
    [SUBTYPE.INSTAGRAM_STORY]: 'story',
    [SUBTYPE.PINTEREST_PHOTO_EXTENDED]: 'pinterest_photo_extended',
    [SUBTYPE.INSTAGRAM_SLIDESHOW]: 'slideshow',
  } as { [x: number]: string },
  getExactName: (type: number, subtype?: number): string => {
    return subtype && !!PostTypeUtils.subtypeName[subtype]
      ? PostTypeUtils.subtypeName[subtype]
      : PostTypeUtils.typeName[type] ?? '';
  },
};

export default PostTypeUtils;
